import React, { useState } from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
import { ListingCard } from '../components/ListingCard';
import { allGoods } from '../data/mockData';
export function GoodsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('newest');
  const filteredGoods = allGoods.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => {
    if (sortBy === 'views') return b.views - a.views;
    if (sortBy === 'price-low') return (a.price || 0) - (b.price || 0);
    if (sortBy === 'price-high') return (b.price || 0) - (a.price || 0);
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
  return <main className="min-h-screen bg-gray-50" data-id="element-365">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-16 px-4" data-id="element-366">
        <div className="max-w-4xl mx-auto text-center" data-id="element-367">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-368">Explore Goods</h1>
          <p className="text-xl text-blue-100" data-id="element-369">
            Discover unique handcrafted items from Nakuru's talented artisans
          </p>
        </div>
      </section>

      <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-370">
        {/* Search and Filter */}
        <div className="bg-white rounded-xl shadow-md p-4 mb-8" data-id="element-371">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-372">
            <div className="flex-1 relative" data-id="element-373">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-374" />
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search goods..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-375" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-376">
              <FilterIcon className="text-gray-400 w-5 h-5" data-id="element-377" />
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-378">
                <option value="newest" data-id="element-379">Newest First</option>
                <option value="views" data-id="element-380">Most Viewed</option>
                <option value="price-low" data-id="element-381">Price: Low to High</option>
                <option value="price-high" data-id="element-382">Price: High to Low</option>
              </select>
            </div>
          </div>
        </div>

        {/* Results Count */}
        <p className="text-gray-600 mb-6" data-id="element-383">
          Showing {filteredGoods.length}{' '}
          {filteredGoods.length === 1 ? 'item' : 'items'}
        </p>

        {/* Goods Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-384">
          {filteredGoods.map(item => <ListingCard key={item.id} listing={item} data-id="element-385" />)}
        </div>

        {filteredGoods.length === 0 && <div className="text-center py-12" data-id="element-386">
            <p className="text-gray-500 text-lg" data-id="element-387">
              No goods found matching your search.
            </p>
          </div>}
      </section>
    </main>;
}